var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"uk-button uk-button-link uk-button-mini",class:{'uk-active': !!_vm.value},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}},[_c('open-icon',{attrs:{"glyph":!!_vm.value ? 'star' : 'star-o'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }